(function() {
    window.c24.lp.ac.hub = {

        init: function() {
            window.c24.lp.ac.addDefaultQtips('hub');

            window.c24.lp.ac.addQTip({
                acType: 'hub',
                hoverElement: '.box24TeaserInfo',
                toolTipChild: '.js24Tooltip',
                arrowPosition: 'top center',
                parentPosition: 'bottom center',
                viewport: $(window),
            });
        },
    };

    $(document).ready(function() {
        window.c24.lp.ac.hub.init();
    });
})();
